import React from 'react';
import { CommentsMsgHeaderStyle, CommentsMsgStyle } from './Styled';
import { getMsgReviews } from '../../../helpers';

interface CommentsMsgProps {
  numberReviews: number;
  numberComments: number;
  onHeader?: boolean;
}

const CommentsMsg = (props: CommentsMsgProps) => {
  const { onHeader, numberComments, numberReviews } = props;
  const textMsg = getMsgReviews({ numberComments, numberReviews });

  if (onHeader) {
    return (
      <>
        <CommentsMsgHeaderStyle className="product-review-comments-message-on-header">
          {numberReviews} nota{`${numberReviews > 1 ? 's ' : ' '}pra esse produto`}
        </CommentsMsgHeaderStyle>
      </>
    );
  }

  return <CommentsMsgStyle className="product-review-comments-message">{textMsg}</CommentsMsgStyle>;
};

CommentsMsg.defaultProps = {
  children: '',
};

export default CommentsMsg;
export { CommentsMsg };
